/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import CloseAction from './CloseAction/index'
import Filters from './Filters/index'
import FiltersAction from './FiltersAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Profiles from './Profiles/index'
import React from 'react'
import SearchTermInput from './SearchTermInput/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/Search/Patient/Search/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={1}
 onDismiss={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<SearchTermInput
  viewPath={`${viewPath}/SearchTermInput`}
/>
<FiltersAction
  viewPath={`${viewPath}/FiltersAction`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Filters
  viewPath={`${viewPath}/Filters`}
/>
</div>
<Profiles
  viewPath={`${viewPath}/Profiles`}
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}